// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.subscriptions-tab[data-v-d3352d0e] {\n    border: 1px solid #e1e1e1;\n    margin-top: 30px;\n    padding: 20px;\n    text-align: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
